import { get } from './api-service';

const routes = {
  base: 'order-status',
};

export const getOrderStatuses = async () => {
  return await get(`${routes.base}`);
}
